import type { AlertItem, Suite } from '../../../data/types/platform';

export interface AlertsProps {
  alerts: AlertItem[];
  suites: Suite[];
  goToSystem: (systemId: string, moduleId?: string) => void;
}

export function Alerts({ alerts, suites, goToSystem }: AlertsProps) {
  return (
    <div className="rail-panel">
      <div className="rp-head">
        <h3>התראות</h3>
        <span className="rp-count">{alerts.length} פתוחות</span>
        <button className="rp-more" type="button">הכל</button>
      </div>
      {alerts.map((a) => {
        const suite = suites.find((x) => x.id === a.suite);
        return (
          <div className="alert-row" key={a.id} onClick={() => goToSystem(a.suite, a.module)}>
            <span className={'a-dot ' + a.level} />
            <div>
              <div className="a-text">{a.he}</div>
              <div className="a-meta">{suite?.he} · {a.module}</div>
            </div>
            <div className="a-time">{a.time}</div>
          </div>
        );
      })}
    </div>
  );
}
